import React, { useState } from "react";
import "./DashboardNavbar.css";
import askCoachIcon from "../assets/icons/ask-coach-icon.png";

const DashboardNavbar = ({ onButtonClick, onLogout }) => {
  const [menuOpen, setMenuOpen] = useState(false); // State for mobile menu toggle

  const handleButtonClick = (buttonName) => {
    if (buttonName === "ask-coach") {
      console.log("Ask Coach button clicked.");
      onButtonClick(buttonName); // Trigger parent function to render Ask Coach
    } else {
      onButtonClick(buttonName);
    }
  };

  return (
    <nav className="dashboard-navbar">
      {/* Desktop Navbar */}
      <div className="desktop-navbar">
        {/* Ask Coach Button */}
        <button
          className="navbar-button navbar-ask-coach"
          onClick={() => handleButtonClick("ask-coach")}
        >
          <img
            src={askCoachIcon} // Updated path for the icon
            alt="Ask Coach"
            className="ask-coach-icon-navbar"
          />
          Ask Coach
        </button>
        <button
          className="navbar-button"
          onClick={() => handleButtonClick("Create Account Plan Workflow")}
        >
          Create Account Plan Workflow
        </button>
        <button
          className="navbar-button"
          onClick={() => handleButtonClick("Create Opportunity")}
        >
          Create Opportunity
        </button>
        <button
          className="navbar-button"
          onClick={() => handleButtonClick("Create Account Plan")}
        >
          Create Account Plan
        </button>
        <button className="navbar-button" disabled>
          Pipeline Generation (Future Release)
        </button>
        <button className="navbar-button" onClick={onLogout}>
          Logout
        </button>
      </div>

      {/* Mobile Navbar */}
      <div className="mobile-navbar">
        <button
          className="hamburger-menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? "Close" : "Menu"}
        </button>
        {menuOpen && (
          <div className="mobile-menu">
            <button
              className="navbar-button navbar-ask-coach"
              onClick={() => handleButtonClick("ask-coach")}
            >
              <img
                src="/content/images/ask_coach.png" // Updated path for the icon
                alt="Ask Coach"
                className="ask-coach-icon-navbar"
              />
              Ask Coach
            </button>
            <button
              className="navbar-button"
              onClick={() => handleButtonClick("Create Account Plan Workflow")}
            >
              Create Account Plan Workflow
            </button>
            <button
              className="navbar-button"
              onClick={() => handleButtonClick("Create Opportunity")}
            >
              Create Opportunity
            </button>
            <button
              className="navbar-button"
              onClick={() => handleButtonClick("Create Account Plan")}
            >
              Create Account Plan
            </button>
            <button className="navbar-button" disabled>
              Pipeline Generation (Future Release)
            </button>
            <button className="navbar-button" onClick={onLogout}>
              Logout
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default DashboardNavbar;
